// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/home/GuestPerks.tsx
// 🔧 PURPOSE: I tre vantaggi sotto la card di benvenuto della vista ospite
//             (mockup Ospite): Check-in online, A due passi dal mare,
//             Reception 24h. Icona d'oro nel cerchio espresso, titolo e una
//             riga. Solo da leggere: le azioni stanno nella card sopra.
// ============================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import { KeyRound, MessageCircle, Waves, type LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';
import { IconCircle, INK_TEXT, MUTED_TEXT, Section } from './ui';

const PERKS: { key: 'checkin' | 'sea' | 'reception'; icon: LucideIcon }[] = [
  { key: 'checkin', icon: KeyRound },
  { key: 'sea', icon: Waves },
  { key: 'reception', icon: MessageCircle },
];

const GuestPerks: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useTranslation();
  return (
    <Section className={className}>
      <ul className="m-0 grid list-none grid-cols-3 gap-2 p-0">
        {PERKS.map(({ key, icon: Icon }) => (
          <li key={key} className="flex min-w-0 flex-col items-center gap-1.5 p-1 text-center">
            <IconCircle tone="ink" size={44}>
              <Icon strokeWidth={1.9} />
            </IconCircle>
            <span className={cn('break-words text-[13.5px] font-bold leading-tight', INK_TEXT)}>
              {t(`home.guest.perks.${key}.title`)}
            </span>
            <span className={cn('break-words text-[12px] leading-snug', MUTED_TEXT)}>{t(`home.guest.perks.${key}.sub`)}</span>
          </li>
        ))}
      </ul>
    </Section>
  );
};

export default GuestPerks;
